import { GTCampaignArea } from 'gql/types.generated'

export const ALL_CAMPAIGN_AREAS_LIST = Object.values(GTCampaignArea)
